export default __webpack_public_path__ + "static/cookies-2d5902108b541d673917c0a0983e9a4c.jpg";